/*@flow*/
import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';

export const GetNearbyResources = (gql(`
  query GetNearbyResources(
    $theGeom: String!
    $targetRelation: String!
    $searchRadiusInMeters: Int!
  ) {
    me {
      id
      company {
        id
        nearbyResources(
          theGeom: $theGeom
          targetRelation: $targetRelation
          searchRadiusInMeters: $searchRadiusInMeters
        ) {
          ... on Unit {
            __typename
            id
            name
          }
        }
      }
    }
  }
`): DocumentNode);
